import { gsap } from 'gsap/all'

const graphCard = {
  el: {
    cards: <NodeListOf<HTMLElement>>document.querySelectorAll('.card--graph'),
  },

  init() {
    if (!this.el.cards.length) return

    this.el.cards.forEach((card: HTMLElement) => {
      this.setPercentage(card)
    })
  },

  setPercentage(card: HTMLElement) {
    const graph = <HTMLElement>card.querySelector('.card__graph')
    const graphRing = <HTMLElement>card.querySelector('.card__graph-ring')
    const percentage = graph.dataset.percentage

    gsap.set(graphRing, {
      drawSVG: `0 ${percentage}%`,
      rotation: -90,
      transformOrigin: '50% 50%',
    })
  },
}

export default graphCard
